import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/normalize.css'
import  initContents  from './config/index.js'

Vue.config.productionTip = false
Vue.use(initContents);

new Vue({
  router,
    data: function () {
        return {
        }
    },
  render: h => h(App)
}).$mount('#app')
